<section class="card">
  <!-- Header -->
  <div class="card-header">
    <h3 class="card-title">
      {{ 'bookingModule.createBookings' | translate }}

      <i
        class="ms-2 fa fa-question-circle"
        role="button"
        tabindex="0"
        [tooltip]="'courseModule.childBookingTooltip' | translate"
      ></i>
    </h3>
  </div>

  <!-- Body start -->
  <booking-create
    *ngIf="(course$ | async)?.id"
    [hideHeaderSections]="true"
    [courseId]="(course$ | async)?.id"
  ></booking-create>
</section>
